/* eslint-disable */
import Long from 'long'
import * as _m0 from 'protobufjs/minimal'
import { Timestamp } from '../../google/protobuf/timestamp'

export const protobufPackage = 'Reality.Reality.Api'

export enum GachaConsumeTypeType {
  GACHA_CONSUME_TYPE_TYPE_UNKNOWN = 0,
  GACHA_CONSUME_TYPE_TYPE_COIN = 1,
  GACHA_CONSUME_TYPE_TYPE_TICKET = 2,
  UNRECOGNIZED = -1,
}

export function gachaConsumeTypeTypeFromJSON(
  object: any
): GachaConsumeTypeType {
  switch (object) {
    case 0:
    case 'GACHA_CONSUME_TYPE_TYPE_UNKNOWN':
      return GachaConsumeTypeType.GACHA_CONSUME_TYPE_TYPE_UNKNOWN
    case 1:
    case 'GACHA_CONSUME_TYPE_TYPE_COIN':
      return GachaConsumeTypeType.GACHA_CONSUME_TYPE_TYPE_COIN
    case 2:
    case 'GACHA_CONSUME_TYPE_TYPE_TICKET':
      return GachaConsumeTypeType.GACHA_CONSUME_TYPE_TYPE_TICKET
    case -1:
    case 'UNRECOGNIZED':
    default:
      return GachaConsumeTypeType.UNRECOGNIZED
  }
}

export function gachaConsumeTypeTypeToJSON(
  object: GachaConsumeTypeType
): string {
  switch (object) {
    case GachaConsumeTypeType.GACHA_CONSUME_TYPE_TYPE_UNKNOWN:
      return 'GACHA_CONSUME_TYPE_TYPE_UNKNOWN'
    case GachaConsumeTypeType.GACHA_CONSUME_TYPE_TYPE_COIN:
      return 'GACHA_CONSUME_TYPE_TYPE_COIN'
    case GachaConsumeTypeType.GACHA_CONSUME_TYPE_TYPE_TICKET:
      return 'GACHA_CONSUME_TYPE_TYPE_TICKET'
    default:
      return 'UNKNOWN'
  }
}

export enum GachaConsumeTypeBonusType {
  GACHA_CONSUME_TYPE_BONUS_TYPE_UNKNOWN = 0,
  GACHA_CONSUME_TYPE_BONUS_TYPE_NONE = 1,
  GACHA_CONSUME_TYPE_BONUS_TYPE_AVATAR_POINT_500 = 2,
  UNRECOGNIZED = -1,
}

export function gachaConsumeTypeBonusTypeFromJSON(
  object: any
): GachaConsumeTypeBonusType {
  switch (object) {
    case 0:
    case 'GACHA_CONSUME_TYPE_BONUS_TYPE_UNKNOWN':
      return GachaConsumeTypeBonusType.GACHA_CONSUME_TYPE_BONUS_TYPE_UNKNOWN
    case 1:
    case 'GACHA_CONSUME_TYPE_BONUS_TYPE_NONE':
      return GachaConsumeTypeBonusType.GACHA_CONSUME_TYPE_BONUS_TYPE_NONE
    case 2:
    case 'GACHA_CONSUME_TYPE_BONUS_TYPE_AVATAR_POINT_500':
      return GachaConsumeTypeBonusType.GACHA_CONSUME_TYPE_BONUS_TYPE_AVATAR_POINT_500
    case -1:
    case 'UNRECOGNIZED':
    default:
      return GachaConsumeTypeBonusType.UNRECOGNIZED
  }
}

export function gachaConsumeTypeBonusTypeToJSON(
  object: GachaConsumeTypeBonusType
): string {
  switch (object) {
    case GachaConsumeTypeBonusType.GACHA_CONSUME_TYPE_BONUS_TYPE_UNKNOWN:
      return 'GACHA_CONSUME_TYPE_BONUS_TYPE_UNKNOWN'
    case GachaConsumeTypeBonusType.GACHA_CONSUME_TYPE_BONUS_TYPE_NONE:
      return 'GACHA_CONSUME_TYPE_BONUS_TYPE_NONE'
    case GachaConsumeTypeBonusType.GACHA_CONSUME_TYPE_BONUS_TYPE_AVATAR_POINT_500:
      return 'GACHA_CONSUME_TYPE_BONUS_TYPE_AVATAR_POINT_500'
    default:
      return 'UNKNOWN'
  }
}

export interface GachaConsumeType {
  type: GachaConsumeTypeType
  /** "コイン" */
  name: string
  /** 500 */
  amount: number
  ticketTypeId: number
  /** 1（通常）or 10（10連） */
  times: number
  discountAmount: number
  discountPercent: number
  remainingCount: number
  hasRemainingCount: boolean
  isDiscount: boolean
  consumeTypeBonusType: GachaConsumeTypeBonusType
  startAt?: Date | undefined
  endAt?: Date | undefined
}

function createBaseGachaConsumeType(): GachaConsumeType {
  return {
    type: 0,
    name: '',
    amount: 0,
    ticketTypeId: 0,
    times: 0,
    discountAmount: 0,
    discountPercent: 0,
    remainingCount: 0,
    hasRemainingCount: false,
    isDiscount: false,
    consumeTypeBonusType: 0,
    startAt: undefined,
    endAt: undefined,
  }
}

export const GachaConsumeType = {
  encode(
    message: GachaConsumeType,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type)
    }
    if (message.name !== '') {
      writer.uint32(18).string(message.name)
    }
    if (message.amount !== 0) {
      writer.uint32(24).int64(message.amount)
    }
    if (message.ticketTypeId !== 0) {
      writer.uint32(32).int64(message.ticketTypeId)
    }
    if (message.times !== 0) {
      writer.uint32(40).int64(message.times)
    }
    if (message.discountAmount !== 0) {
      writer.uint32(48).int64(message.discountAmount)
    }
    if (message.discountPercent !== 0) {
      writer.uint32(56).int64(message.discountPercent)
    }
    if (message.remainingCount !== 0) {
      writer.uint32(64).int64(message.remainingCount)
    }
    if (message.hasRemainingCount === true) {
      writer.uint32(72).bool(message.hasRemainingCount)
    }
    if (message.isDiscount === true) {
      writer.uint32(80).bool(message.isDiscount)
    }
    if (message.consumeTypeBonusType !== 0) {
      writer.uint32(88).int32(message.consumeTypeBonusType)
    }
    if (message.startAt !== undefined) {
      Timestamp.encode(
        toTimestamp(message.startAt),
        writer.uint32(98).fork()
      ).ldelim()
    }
    if (message.endAt !== undefined) {
      Timestamp.encode(
        toTimestamp(message.endAt),
        writer.uint32(106).fork()
      ).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GachaConsumeType {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGachaConsumeType()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.type = reader.int32() as any
          break
        case 2:
          message.name = reader.string()
          break
        case 3:
          message.amount = longToNumber(reader.int64() as Long)
          break
        case 4:
          message.ticketTypeId = longToNumber(reader.int64() as Long)
          break
        case 5:
          message.times = longToNumber(reader.int64() as Long)
          break
        case 6:
          message.discountAmount = longToNumber(reader.int64() as Long)
          break
        case 7:
          message.discountPercent = longToNumber(reader.int64() as Long)
          break
        case 8:
          message.remainingCount = longToNumber(reader.int64() as Long)
          break
        case 9:
          message.hasRemainingCount = reader.bool()
          break
        case 10:
          message.isDiscount = reader.bool()
          break
        case 11:
          message.consumeTypeBonusType = reader.int32() as any
          break
        case 12:
          message.startAt = fromTimestamp(
            Timestamp.decode(reader, reader.uint32())
          )
          break
        case 13:
          message.endAt = fromTimestamp(
            Timestamp.decode(reader, reader.uint32())
          )
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },

  fromJSON(object: any): GachaConsumeType {
    return {
      type: isSet(object.type) ? gachaConsumeTypeTypeFromJSON(object.type) : 0,
      name: isSet(object.name) ? String(object.name) : '',
      amount: isSet(object.amount) ? Number(object.amount) : 0,
      ticketTypeId: isSet(object.ticketTypeId)
        ? Number(object.ticketTypeId)
        : 0,
      times: isSet(object.times) ? Number(object.times) : 0,
      discountAmount: isSet(object.discountAmount)
        ? Number(object.discountAmount)
        : 0,
      discountPercent: isSet(object.discountPercent)
        ? Number(object.discountPercent)
        : 0,
      remainingCount: isSet(object.remainingCount)
        ? Number(object.remainingCount)
        : 0,
      hasRemainingCount: isSet(object.hasRemainingCount)
        ? Boolean(object.hasRemainingCount)
        : false,
      isDiscount: isSet(object.isDiscount) ? Boolean(object.isDiscount) : false,
      consumeTypeBonusType: isSet(object.consumeTypeBonusType)
        ? gachaConsumeTypeBonusTypeFromJSON(object.consumeTypeBonusType)
        : 0,
      startAt: isSet(object.startAt)
        ? fromJsonTimestamp(object.startAt)
        : undefined,
      endAt: isSet(object.endAt) ? fromJsonTimestamp(object.endAt) : undefined,
    }
  },

  toJSON(message: GachaConsumeType): unknown {
    const obj: any = {}
    message.type !== undefined &&
      (obj.type = gachaConsumeTypeTypeToJSON(message.type))
    message.name !== undefined && (obj.name = message.name)
    message.amount !== undefined && (obj.amount = Math.round(message.amount))
    message.ticketTypeId !== undefined &&
      (obj.ticketTypeId = Math.round(message.ticketTypeId))
    message.times !== undefined && (obj.times = Math.round(message.times))
    message.discountAmount !== undefined &&
      (obj.discountAmount = Math.round(message.discountAmount))
    message.discountPercent !== undefined &&
      (obj.discountPercent = Math.round(message.discountPercent))
    message.remainingCount !== undefined &&
      (obj.remainingCount = Math.round(message.remainingCount))
    message.hasRemainingCount !== undefined &&
      (obj.hasRemainingCount = message.hasRemainingCount)
    message.isDiscount !== undefined && (obj.isDiscount = message.isDiscount)
    message.consumeTypeBonusType !== undefined &&
      (obj.consumeTypeBonusType = gachaConsumeTypeBonusTypeToJSON(
        message.consumeTypeBonusType
      ))
    message.startAt !== undefined &&
      (obj.startAt = message.startAt.toISOString())
    message.endAt !== undefined && (obj.endAt = message.endAt.toISOString())
    return obj
  },

  fromPartial<I extends Exact<DeepPartial<GachaConsumeType>, I>>(
    object: I
  ): GachaConsumeType {
    const message = createBaseGachaConsumeType()
    message.type = object.type ?? 0
    message.name = object.name ?? ''
    message.amount = object.amount ?? 0
    message.ticketTypeId = object.ticketTypeId ?? 0
    message.times = object.times ?? 0
    message.discountAmount = object.discountAmount ?? 0
    message.discountPercent = object.discountPercent ?? 0
    message.remainingCount = object.remainingCount ?? 0
    message.hasRemainingCount = object.hasRemainingCount ?? false
    message.isDiscount = object.isDiscount ?? false
    message.consumeTypeBonusType = object.consumeTypeBonusType ?? 0
    message.startAt = object.startAt ?? undefined
    message.endAt = object.endAt ?? undefined
    return message
  },
}

declare var self: any | undefined
declare var window: any | undefined
declare var global: any | undefined
var globalThis: any = (() => {
  if (typeof globalThis !== 'undefined') return globalThis
  if (typeof self !== 'undefined') return self
  if (typeof window !== 'undefined') return window
  if (typeof global !== 'undefined') return global
  throw 'Unable to locate global object'
})()

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<
        Exclude<keyof I, KeysOfUnion<P>>,
        never
      >

function toTimestamp(date: Date): Timestamp {
  const seconds = date.getTime() / 1_000
  const nanos = (date.getTime() % 1_000) * 1_000_000
  return { seconds, nanos }
}

function fromTimestamp(t: Timestamp): Date {
  let millis = t.seconds * 1_000
  millis += t.nanos / 1_000_000
  return new Date(millis)
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o
  } else if (typeof o === 'string') {
    return new Date(o)
  } else {
    return fromTimestamp(Timestamp.fromJSON(o))
  }
}

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error('Value is larger than Number.MAX_SAFE_INTEGER')
  }
  return long.toNumber()
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any
  _m0.configure()
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}
